import { useState, useEffect } from "react";
import styles from "./Notifications.module.scss";
import Loading from "../../../components/common/loading/Loading";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import AccountSidebar from "../../../components/common/account-sidebar/AccountSidebar";
import { useTranslation } from "react-i18next";

interface Notification {
  id: number;
  title: string;
  message: string;
  date: string;
  isRead: boolean;
}

const Notifications = () => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const { t } = useTranslation("translation");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        // TODO: API servisi ilə əlaqələndirmək
        // const res = await NotificationService.getNotifications();
        // setNotifications(res.data);

        // Müvəqqəti test məlumatları
        setNotifications([
          {
            id: 1,
            title: "Yeni mesaj",
            message: "LuxMart yeniləndı 🎉",
            date: "2024-01-20",
            isRead: false,
          },
          {
            id: 2,
            title: "Sifarişiniz yoldadır",
            message: "Sifarişiniz №45821 kuryer tərəfindən götürüldü",
            date: "2024-01-19",
            isRead: true,
          },
        ]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  const markAsRead = (id: number) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id ? { ...notif, isRead: true } : notif,
      ),
    );
  };

  const markAllAsRead = () => {
    setNotifications((prev) =>
      prev.map((notif) => ({ ...notif, isRead: true })),
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.notifications}>
      <TitleUpdater title={t("notifications")} />
      <div className="container">
        <div className={styles.wrapper}>
          <AccountSidebar />
          <div className={styles.content}>
            <div className={styles.header}>
              <h1 className={styles.pageTitle}>
                {t("notifications") || "Bildirişlər"}
              </h1>
              {notifications.some((n) => !n.isRead) && (
                <button className={styles.markAllBtn} onClick={markAllAsRead}>
                  {t("mark_all_as_read") || "Hamısını oxunmuş kimi işarələ"}
                </button>
              )}
            </div>

            {notifications.length === 0 ? (
              <div className={styles.emptyState}>
                <p>{t("no_notifications") || "Bildiriş yoxdur"}</p>
              </div>
            ) : (
              <div className={styles.notificationList}>
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`${styles.notificationItem} ${
                      !notification.isRead ? styles.unread : ""
                    }`}
                    onClick={() =>
                      !notification.isRead && markAsRead(notification.id)
                    }
                  >
                    <div className={styles.notificationHeader}>
                      <h3 className={styles.notificationTitle}>
                        {notification.title}
                      </h3>
                      <span className={styles.notificationDate}>
                        {new Date(notification.date).toLocaleDateString(
                          "az-AZ",
                        )}
                      </span>
                    </div>
                    <p className={styles.notificationMessage}>
                      {notification.message}
                    </p>
                    {!notification.isRead && (
                      <span className={styles.unreadBadge}></span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
